import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import { isHashRouterMode, publicPath, authentication } from '@/config'
import { setupPermissions } from './permissions'
import Main from '@/views/Main.vue'
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/login'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/forgetPwd',
    name: 'ForgetPwd',
    component: () => import('@/views/login/forgetPwd'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/systemSet',
    name: 'SystemSet',
    component: () => import('@/views/setting/systemSet'),
    meta: {
      hidden: true,
      title: '修改菜单',
      icon: 'settings-2-line',
    },
  },
  {
    path: '/busAdmin',
    name: 'busAdmin',
    component: () => import('@/views/setting/systemSet/busAdmin'),
    meta: {
      hidden: true,
      title: '业务菜单',
      icon: 'settings-2-line',
    },
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    component: () => import('@/views/enterprise/index'),
    meta: {
      hidden: true,
      title: '企业官网',
      icon: 'settings-2-line',
    },
  },
  {
    path: '/deploy/dataClear',
    name: 'DataClear',
    component: () => import('@/views/tool/dataClear.vue'),
    meta: {
      hidden: true,
      title: '数据清除',
    },
  },
]
export const asyncRoutes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: { title: '首页', icon: 'HomeFilled' },
  },
  /* {
    path: '/user/userList',
    name: 'User',
    component: Layout,
    meta: {
      title: '用户管理',
      icon: 'Avatar',
    },
    children: [
      {
        path: '/user/userList',
        name: 'UserList',
        component: () => import('@/views/user/list/userList.vue'),
        meta: {
          title: '用户列表',
          icon: 'UserFilled',
          twoCategroy: 'none',
        },
        children: [
          {
            path: '/user/userDetail',
            name: 'userDetail',
            component: () => import('@/views/user/list/userDetail.vue'),
            meta: {
              title: '用户详情',
              icon: 'UserFilled',
              display: 'none',
            },
          },
        ],
      },
      {
        path: '/user/audit',
        name: 'Audit',
        component: () => import('@/views/user/audit/index.vue'),
        meta: { title: '待审核用户', icon: 'UserFilled', twoCategroy: 'none' },
        children: [
          {
            path: '/user/auditDetail',
            name: 'userAuditDetail',
            component: () => import('@/views/user/audit/auditDetail.vue'),
            meta: {
              title: '用户详情',
              icon: 'UserFilled',
              display: 'none',
            },
          },
        ],
      },
      {
        path: '/user/noPass',
        name: 'NoPass',
        component: () => import('@/views/user/noPass/index.vue'),
        meta: { title: '未通过用户', icon: 'UserFilled', twoCategroy: 'none' },
        children: [
          {
            path: '/user/noPassDetail',
            name: 'userNoPassDetail',
            component: () => import('@/views/user/noPass/noPassDetail.vue'),
            meta: {
              title: '用户详情',
              icon: 'UserFilled',
              display: 'none',
            },
          },
        ],
      },
      {
        path: '/user/grouping',
        name: 'Grouping',
        component: () => import('@/views/user/grouping/index.vue'),
        meta: { title: '用户分组', icon: 'Stamp' },
      },
      {
        path: '/user/recycle',
        name: 'Recycle',
        component: () => import('@/views/user/recycle/index.vue'),
        meta: { title: '回收站', icon: 'DeleteFilled' },
      },
      {
        path: '/contacts/list',
        name: 'Contacts',
        meta: { title: '客服列表', icon: 'Avatar' },
        component: () => import('@/views/site/contacts/list.vue'),
      },
    ],
  }, */
  /* {
    path: '/store/index',
    name: 'Store',
    component: Layout,
    meta: {
      title: '店铺管理',
      icon: 'Shop',
    },
    children: [
      {
        path: '/store/index',
        name: 'storeIndex',
        component: () => import('@/views/store/index.vue'),
        meta: { title: '店铺管理', icon: 'Menu', twoCategroy: 'none' },
        children: [
          {
            path: '/store/storeDetail',
            name: 'storeDetail',
            component: () => import('@/views/store/storeDetail/index.vue'),
            meta: {
              title: '店铺详情',
              icon: 'UserFilled',
              display: 'none',
            },
          },
          {
            path: '/store/createStore',
            name: 'createStore',
            component: () => import('@/views/store/createStore.vue'),
            meta: {
              title: '创建店铺',
              icon: 'UserFilled',
              display: 'none',
            },
          },
          {
            path: '/store/editStore',
            name: 'storeEditStore',
            component: () => import('@/views/store/editStore.vue'),
            meta: {
              title: '编辑店铺',
              icon: 'UserFilled',
              display: 'none',
            },
          },
        ],
      },
      {
        path: '/store/experience',
        name: 'experience',
        component: () => import('@/views/store/experience.vue'),
        meta: { title: '体验店铺', icon: 'GoodsFilled' },
      },
      // {
      //   path: '/store/create',
      //   name: 'create',
      //   component: () => import('@/views/store/create.vue'),
      //   meta: { title: '待创建店铺', icon: 'GoodsFilled', twoCategroy: 'none' },
      //   children: [
      //     {
      //       path: '/store/createDetail',
      //       name: 'storeCreateDetail',
      //       component: () => import('@/views/store/createDetail.vue'),
      //       meta: { title: '套餐管理', icon: 'Briefcase', display: 'none' },
      //     },
      //   ],
      // },
      /* {
        path: '/store/audit',
        name: 'audit',
        component: () => import('@/views/store/audit.vue'),
        meta: { title: '待审核店铺', icon: 'GoodsFilled' },
      },
      {
        path: '/store/reject',
        name: 'reject',
        component: () => import('@/views/store/reject.vue'),
        meta: { title: '拒绝店铺', icon: 'Failed', twoCategroy: 'none' },
        children: [
          {
            path: '/store/rejectDetail',
            name: 'storeRejectDetail',
            component: () => import('@/views/store/rejectDetail.vue'),
            meta: { title: '店铺详情', icon: 'Briefcase', display: 'none' },
          },
        ],
      }, */
  /*  {
        path: '/store/recycle',
        name: 'recycle',
        component: () => import('@/views/store/recycle.vue'),
        meta: { title: '回收站', icon: 'DeleteFilled' },
      },
    ],
  }, */
  /* {
    path: '/package',
    name: 'Package',
    component: Layout,
    meta: { title: '套餐管理', icon: 'GoodsFilled' },
    children: [
      {
        path: '/package',
        name: 'packageIndex',
        component: () => import('@/views/package/packageList/index.vue'),
        meta: { title: '套餐管理', icon: 'Briefcase', twoCategroy: 'none' },
        // children: [
        //   {
        //     path: '/package/create',
        //     name: 'packageCreate',
        //     component: () => import('@/views/package/create/index.vue'),
        //     meta: {
        //       title: '创建套餐',
        //       icon: 'UserFilled',
        //       display: 'none',
        //     },
        //   },
        // ],
      },
      /* {
        path: '/package/create',
        name: 'packageCreate',
        component: () => import('@/views/package/create/index.vue'),
        meta: {
          title: '创建套餐',
          icon: 'UserFilled',
          display: 'none',
          hidden: true,
        },
      },
      {
        path: '/package/app',
        name: 'packageApp',
        component: () => import('@/views/package/app.vue'),
        meta: { title: '应用管理', icon: 'Grid', twoCategroy: 'none' },
        children: [
          {
            path: '/package/appConfig',
            name: 'packageAppConfig',
            component: () => import('@/views/package/appConfig.vue'),
            meta: {
              title: '应用配置',
              icon: 'UserFilled',
              display: 'none',
            },
          },
        ],
      }, */
  // {
  //   path: '/package/channel',
  //   name: 'packageChannel',
  //   component: () => import('@/views/package/channel.vue'),
  //   meta: { title: '渠道管理', icon: 'Checked', twoCategroy: 'none' },
  //   children: [
  //     {
  //       path: '/package/channelConfig',
  //       name: 'packageChannelConfig',
  //       component: () => import('@/views/package/channelConfig.vue'),
  //       meta: {
  //         title: '渠道配置',
  //         icon: 'UserFilled',
  //         display: 'none',
  //       },
  //     },
  //   ],
  // },
  /* {
        path: '/package/Order',
        name: 'Order',
        component: () => import('@/views/package/order.vue'),
        meta: { title: '订单管理', icon: 'List', twoCategroy: 'none' },
        children: [
          {
            path: '/package/orderDetail',
            name: 'packageOrderDetail',
            component: () => import('@/views/package/orderDetail.vue'),
            meta: {
              title: '订单详情',
              icon: 'UserFilled',
              display: 'none',
            },
          },
        ],
      }, */
  // {
  //   path: '/package/sms',
  //   name: 'packageSms',
  //   component: () => import('@/views/package/sms.vue'),
  //   meta: { title: '短信套餐', icon: 'List', twoCategroy: 'none' },
  //   children: [
  //     {
  //       path: '/package/addSms',
  //       name: 'packageAddSms',
  //       component: () => import('@/views/package/addSms.vue'),
  //       meta: {
  //         title: '添加套餐',
  //         icon: 'UserFilled',
  //         display: 'none',
  //       },
  //     },
  //   ],
  // },
  /* ],
  }, */
  /*  {
    path: '/tool/index',
    name: 'Tool',
    component: Layout,
    meta: { title: '应用工具', icon: 'Grid' },
    children: [
      {
        path: '/tool/index',
        name: 'toolIndex',
        component: () => import('@/views/tool/index.vue'),
        meta: { title: '应用市场', icon: 'Management' },
      },
      {
        path: '/tool/toolList',
        name: 'toolList',
        component: () => import('@/views/tool/toolList.vue'),
        meta: { title: '全部工具', icon: 'Management', twoCategroy: 'none' },
        children: [
          {
            path: '/package/platformNotice',
            name: 'platformNotice',
            component: () => import('@/views/tool/platformNotice.vue'),
            meta: {
              title: '店铺公告',
              icon: 'UserFilled',
              display: 'none',
            },
          },
          {
            path: '/package/addPlatformNotice',
            name: 'addPlatformNotice',
            component: () => import('@/views/tool/addPlatformNotice.vue'),
            meta: {
              title: '添加公告',
              icon: 'UserFilled',
              display: 'none',
            },
          },
          {
            path: '/package/advertising',
            name: 'packageAdvertising',
            component: () => import('@/views/tool/advertising.vue'),
            meta: {
              title: '广告位',
              icon: 'UserFilled',
              display: 'none',
            },
          },
          {
            path: '/package/addAdvertising',
            name: 'packageAddAdvertising',
            component: () => import('@/views/tool/addAdvertising.vue'),
            meta: {
              title: '添加广告位',
              icon: 'UserFilled',
              display: 'none',
            },
          },
          {
            path: '/package/help',
            name: 'packageHelp',
            component: () => import('@/views/tool/packageHelp.vue'),
            meta: {
              title: '系统教程',
              icon: 'UserFilled',
              display: 'none',
            },
          },
          {
            path: '/package/addHelp',
            name: 'packageAddHelp',
            component: () => import('@/views/tool/addHelp.vue'),
            meta: {
              title: '添加帮助',
              icon: 'UserFilled',
              display: 'none',
            },
          },
          {
            path: '/package/weChatLogin',
            name: 'packageWeChatLogin',
            component: () => import('@/views/tool/weChatLogin.vue'),
            meta: {
              title: '微信扫码登录',
              icon: 'UserFilled',
              display: 'none',
            },
          },
        ],
      },
      {
        path: '/tool/payList',
        name: 'payList',
        component: () => import('@/views/tool/paySet/payList'),
        meta: { title: '我的服务', icon: 'Management' },
      },
    ],
  }, */
  /* {
    path: '/authorize/index',
    name: 'Authorize',
    component: Layout,
    meta: { title: '升级与授权', icon: 'UploadFilled' },
    children: [ */
  /* {
        path: '/authorize/index',
        name: 'authorize',
        component: () => import('@/views/authorize/index.vue'),
        meta: { title: '授权管理', icon: 'Management' },
      },
      {
        path: '/authorize/upgrade',
        name: 'upgrade',
        component: () => import('@/views/authorize/upgrade.vue'),
        meta: { title: '系统升级', icon: 'UploadFilled' },
      },
      {
        path: '/authorize/appletUplod',
        name: 'AuthorizeAppletUplod',
        component: () => import('@/views/authorize/appletUplod.vue'),
        meta: { title: '小程序上传', icon: 'UploadFilled' },
      }, */
  /*  {
        path: "/authorize/repair",
        name: "repair",
        component: () => import("@/views/authorize/repair.vue"),
        meta: { title: "系统修复", icon: "SuccessFilled" },
      }, */
  /* {
        path: '/authorize/maintain',
        name: 'authorizeMaintain',
        component: () => import('@/views/authorize/maintain.vue'),
        meta: { title: '系统维护', icon: 'RemoveFilled' },
      },
      {
        path: '/authorize/updateLog',
        name: 'updateLog',
        component: () => import('@/views/authorize/updateLog.vue'),
        meta: { title: '更新日志', icon: 'Promotion' },
      }, */
  /* ],
  }, */
  /* {
    path: '/site/index',
    name: 'Site',
    component: Layout,
    meta: { title: '系统管理', icon: 'Tools' },
    children: [
      {
        path: '/site/index',
        meta: { title: '基本设置', icon: 'Tools' },
        name: 'site',
        component: () => import('@/views/test/test.vue'),
        children: [
          {
            path: '/site/index',
            name: 'siteIndex',
            component: () => import('@/views/site/index.vue'),
            meta: { title: '基本设置' },
          },
          {
            path: '/site/copyright',
            name: 'copyright',
            component: () => import('@/views/site/copyright.vue'),
            meta: { title: '版权设置' },
          },
          {
            path: '/site/thirdplatform',
            name: 'thirdplatform',
            component: () => import('@/views/site/thirdplatform.vue'),
            meta: { title: '微信开放平台设置' },
          },
        ],
      },
      {
        path: '/other/modifyPwd',
        name: 'otherModifyPwd',
        meta: { title: '修改密码', icon: 'Tools', display: 'none' },
        component: () => import('@/views/other/modifyPwd.vue'),
      },
      {
        path: '/site/userSetting',
        name: 'userSetting',
        component: () => import('@/views/site/userSetting.vue'),
        meta: { title: '用户设置', icon: 'UserFilled' },
      },
      {
        path: '/site/accessory',
        name: 'accessory',
        component: () => import('@/views/site/accessory.vue'),
        meta: { title: '附件设置', icon: 'QuestionFilled' },
      },
      {
        path: '/site/storage',
        name: 'storage',
        component: () => import('@/views/site/storage.vue'),
        meta: { title: '远程存储', icon: 'Platform' },
      },
      {
        path: '/payment/set',
        name: 'paymentSet',
        component: () => import('@/views/site/paymentSet.vue'),
        meta: { title: '支付设置', icon: 'WalletFilled' },
      },

      {
        path: '/sms/notice',
        name: 'SmsNotice',
        meta: { title: '短信设置', icon: 'Comment' },
        component: () => import('@/views/test/test.vue'),
        children: [
          // {
          //   path: '/sms/notice',
          //   name: 'notice',
          //   component: () => import('@/views/site/sms/notice.vue'),
          //   meta: { title: '用户通知', icon: 'edit' },
          // },
          {
            path: '/package/sms',
            name: 'packageSms',
            component: () => import('@/views/package/sms.vue'),
            meta: { title: '短信套餐', icon: 'List', twoCategroy: 'none' },
          },
          {
            path: '/sms/set',
            name: 'set',
            component: () => import('@/views/site/sms/set.vue'),
            meta: { title: '短信设置', icon: 'edit' },
          },
        ],
      },
      {
        path: '/log',
        name: 'Log',
        component: () => import('@/views/test/test.vue'),
        meta: { title: '安全日志', icon: 'CirclePlusFilled' },
        children: [
          {
            path: '/log/operation',
            name: 'logOperation',
            component: () => import('@/views/site/log/operation.vue'),
            meta: { title: '操作日志', icon: 'edit' },
          },
          {
            path: '/login/log',
            name: 'loginLog',
            component: () => import('@/views/site/log/loginLog.vue'),
            meta: { title: '登录日志', icon: 'edit' },
          },
        ],
      },
      {
        path: '/material',
        name: 'Material',
        component: () => import('@/views/site/material/index.vue'),
        meta: { title: '素材管理', icon: 'CirclePlusFilled' },
      },
    ],
  }, */
  {
    path: '/deploy',
    name: 'Deploy',
    component: Main,
    redirect: '/deploy/aishopku',
    meta: {
      title: '部署管理',
      icon: 'Setting',
    },
    children: [
      {
        path: 'aishopku',
        name: 'AiShopKu',
        component: () => import('@/views/deploy/aishopku.vue'),
        meta: {
          title: 'AI商品库',
          icon: 'GoodsFilled',
        },
      },
      {
        path: 'manage',
        name: 'DeployManage',
        component: () => import('@/views/deploy/manage.vue'),
        meta: {
          title: '独立部署管理',
          icon: 'Setting',
        },
      },
    ],
  },
  {
    path: '/ai',
    name: 'AiManage',
    component: Main,
    redirect: '/ai/config',
    meta: {
      title: 'AI管理',
      icon: 'Cpu',
    },
    children: [
      {
        path: 'config',
        name: 'AiConfig',
        component: () => import('@/views/tool/aiConfig.vue'),
        meta: {
          title: 'AI应用配置',
          icon: 'Setting',
        },
      },
      {
        path: 'token',
        name: 'AiToken',
        component: () => import('@/views/tool/aiToken.vue'),
        meta: {
          title: 'Token管理',
          icon: 'Coin',
        },
      },
    ],
  },
  {
    path: '/appBuild',
    name: 'AppBuild',
    component: Main,
    redirect: '/appBuild/index',
    meta: {
      title: 'APP打包',
      icon: 'Box',
    },
    children: [
      {
        path: 'index',
        name: 'AppBuildIndex',
        component: () => import('@/views/tool/buildapk/appDistribution.vue'),
        meta: {
          title: 'APP打包',
          icon: 'Box',
        },
      },
      {
        path: 'appVersion',
        name: 'AppVersion',
        component: () => import('@/views/tool/buildapk/appVersion.vue'),
        meta: {
          title: '版本管理',
          icon: 'Upload',
        },
      },
      {
        path: 'updateLog',
        name: 'UpdateLog',
        component: () => import('@/views/authorize/updateLog.vue'),
        meta: {
          title: '更新日志',
          icon: 'Promotion',
        },
      },
      {
        path: 'voiceNotice',
        name: 'VoiceNotice',
        component: () => import('@/views/setting/voiceNotice.vue'),
        meta: {
          title: '语音通知设置',
          icon: 'Bell',
        },
      },
    ],
  },
]

const router = createRouter({
  history: isHashRouterMode
    ? createWebHashHistory(publicPath)
    : createWebHistory(publicPath),
  routes: constantRoutes,
})

//过滤三级菜单
// function fatteningRoutes(routes) {
//   return routes.flatMap((route) => {
//     return route.children ? fatteningRoutes(route.children) : route
//   })
// }

//二级路由不显示
function addRouter(routes) {
  routes.forEach((route) => {
    if (!router.hasRoute(route.name)) router.addRoute(route)
    // if (route.children) addRouter(route.children)
  })
}

export function resetRouter(routes = constantRoutes) {
  // routes.map((route) => {
  //   if (route.children) {
  //     console.log(123, route)
  //     route.children = fatteningRoutes(route.children)
  //   }
  // })
  router.getRoutes().forEach((route) => {
    const routeName = route.name
    router.hasRoute(routeName) && router.removeRoute(routeName)
  })
  addRouter(routes)
}

export function setupRouter(app) {
  if (authentication === 'intelligence') addRouter(asyncRoutes)
  setupPermissions(router)
  app.use(router)
  return router
}

export default router
